const tenants = {
    title: 'การตั้งค่า',
    description: 'จัดการการตั้งค่าผู้เช่าอย่างมีประสิทธิภาพและปรับแต่งโดเมนของคุณ',
    oss_description: 'เปลี่ยนการตั้งค่าบัญชีและจัดการข้อมูลส่วนตัวของคุณที่นี่เพื่อให้มั่นใจถึงความปลอดภัยของบัญชีของคุณ',
    tabs: {
        settings: 'การตั้งค่า',
        members: 'สมาชิก',
        domains: 'โดเมน',
        oidc_configs: 'การกำหนดค่า OIDC',
        subscription: 'แผนและการเรียกเก็บเงิน',
        billing_history: 'ประวัติการเรียกเก็บเงิน',
        license: 'ใบอนุญาต',
    },
    license: {
        purchase_title: 'แผนแบบ SELF-HOSTED',
        purchase_description: 'แผน Pro และแผนองค์กรแบบ self-hosted จะปลดล็อกฟีเจอร์แบบชำระเงินบนอินสแตนซ์ของคุณเอง เช่น การซ่อนแบรนด์ Logto การใช้ UI ของคุณเอง การทำงานร่วมกันในคอนโซล และแอปพลิเคชัน SAML ไม่จำกัด ซื้อแผนเพื่อรับคีย์ใบอนุญาตของคุณ',
        purchase_button: 'ดูแผนแบบ self-hosted',
        install_title: 'ติดตั้งใบอนุญาต',
        install_description: 'วางคีย์ใบอนุญาตที่คุณได้รับหลังจากซื้อแผนแบบ self-hosted',
        install_button: 'ติดตั้งใบอนุญาต',
        key_field: 'คีย์ใบอนุญาต',
        key_field_description: 'คีย์จะถูกตรวจสอบบนอินสแตนซ์ของคุณและไม่ถูกส่งออกไปที่ใด หากคีย์ที่คุณมีหมดอายุแล้ว ให้ติดต่อ Logto เพื่อขอคีย์ใหม่',
        key_placeholder: 'วางคีย์ใบอนุญาตของคุณที่นี่',
        installed_toast: 'ติดตั้งใบอนุญาตเรียบร้อยแล้ว',
        details_title: 'ใบอนุญาต',
        details_description: 'ใบอนุญาตที่ติดตั้งบนอินสแตนซ์นี้และสิทธิ์ที่ได้รับ',
        plan_field: 'แผน',
        environment_field: 'สภาพแวดล้อม',
        environment_production: 'โปรดักชัน',
        environment_non_production: 'ไม่ใช่โปรดักชัน',
        expires_at_field: 'หมดอายุวันที่',
        installed_at_field: 'ติดตั้งเมื่อ',
        last_refreshed_at_field: 'รีเฟรชล่าสุดเมื่อ',
        grace_ends_at_field: 'ระยะเวลาผ่อนผันสิ้นสุดวันที่',
        refresh_expired_description: 'คีย์ใบอนุญาตหมดอายุเมื่อ {{expiresAt}} ฟีเจอร์ที่ได้รับอนุญาตจะยังใช้งานได้จนถึง {{graceEndsAt}} ขณะที่ Logto พยายามรีเฟรชคีย์',
        refresh_refused_description: 'การรีเฟรชใบอนุญาตถูกปฏิเสธ เนื่องจากใบอนุญาต{{reason}} ฟีเจอร์ที่ได้รับอนุญาตจะยังใช้งานได้จนถึง {{graceEndsAt}}',
        refusal_reason_canceled: 'ถูกยกเลิก',
        refusal_reason_unpaid: 'ยังไม่ได้ชำระเงิน',
        refusal_reason_expired: 'หมดอายุ',
        refusal_reason_revoked: 'ถูกเพิกถอน',
        refusal_reason_unknown: 'ไม่พร้อมใช้งาน',
        grace_expired_description: 'ระยะเวลาผ่อนผันของใบอนุญาตสิ้นสุดเมื่อ {{graceEndsAt}} การติดตั้งนี้กลับไปใช้ค่าเริ่มต้นของ OSS แล้ว ติดต่อ Logto เพื่อขอคีย์ใบอนุญาตใหม่และติดตั้งอีกครั้ง',
        get_fresh_key_button: 'รับคีย์ใบอนุญาตใหม่',
        replace_button: 'เปลี่ยนใบอนุญาต',
    },
    members: {
        card_title: 'จัดการเทนแนนต์ได้อย่างปลอดภัยยิ่งขึ้นด้วย Logto Cloud',
        card_description: 'เพิ่มผู้ดูแลระบบหรือผู้ทำงานร่วมกันให้กับเทนแนนต์ของคุณได้โดยไม่ต้องแชร์บัญชีผู้ดูแลระบบเพียงบัญชีเดียว',
        card_action: 'สำรวจ Logto Cloud',
        self_hosted_card_title: 'จัดการเทนแนนต์ได้อย่างปลอดภัยยิ่งขึ้นด้วยแผน self-hosted',
        self_hosted_card_description: 'เพิ่มผู้ดูแลระบบหรือผู้ทำงานร่วมกันให้กับเทนแนนต์ของคุณได้โดยไม่ต้องแชร์บัญชีผู้ดูแลระบบเพียงบัญชีเดียว',
        self_hosted_card_action: 'สำรวจแผน self-hosted',
    },
    settings: {
        title: 'การตั้งค่า',
        description: 'ตั้งชื่อผู้เช่าและดูภูมิภาคโฮสต์ข้อมูลของคุณและประเภทผู้เช่า',
        tenant_id: 'รหัสผู้เช่า',
        tenant_name: 'ชื่อผู้เช่า',
        tenant_instance: 'เลือกอินสแตนซ์ของคุณ',
        tenant_instance_description: 'เลือกสถานที่โฮสต์สำหรับผู้เช่าของคุณ เลือก Logto Cloud สำหรับโครงสร้างพื้นฐานที่ใช้ร่วมกันสาธารณะ หรืออินสแตนซ์ส่วนตัวสำหรับทรัพยากรเฉพาะ',
        tenant_region: 'ภูมิภาคข้อมูล',
        tenant_region_description: 'ตำแหน่งทางกายภาพที่ทรัพยากรผู้เช่าของคุณ (ผู้ใช้, แอปพลิเคชัน ฯลฯ) ถูกโฮสต์ ไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างแล้ว',
        tenant_region_tip: 'ทรัพยากรผู้เช่าของคุณถูกรองรับใน {{region}} <a>เรียนรู้เพิ่มเติม</a>',
        environment_tag_development: 'ทดสอบ',
        environment_tag_production: 'โปรดักชั่น',
        tenant_type: 'ประเภทผู้เช่า',
        development_description: 'ใช้สำหรับทดสอบเท่านั้นและไม่ควรใช้ในโปรดักชั่น ไม่ต้องการการสมัครสมาชิก มีทุกฟีเจอร์โปรแต่มีข้อจำกัด เช่น แบนเนอร์เข้าสู่ระบบ',
        production_description: 'สำหรับแอปที่ถูกใช้งานโดยผู้ใช้งานจริงและอาจต้องการการสมัครสมาชิกแบบชำระเงิน',
        tenant_info_saved: 'บันทึกข้อมูลผู้เช่าสำเร็จ',
        tenant_mfa: 'การยืนยันตัวตนหลายปัจจัย',
        tenant_mfa_description: 'กำหนดให้สมาชิกของคุณตั้งค่าการยืนยันตัวตนหลายปัจจัยเพื่อเข้าถึงผู้เช่านี้',
        oss_description: 'จัดการวิธีที่สมาชิกเข้าถึงคอนโซลบนอินสแตนซ์นี้',
        tenant_mfa_confirm_title: 'กำหนดให้สมาชิกทุกคนต้องใช้ MFA หรือไม่?',
        tenant_mfa_confirm_description: 'สมาชิกเหล่านี้ยังไม่ได้ตั้งค่า MFA พวกเขาจะยังคงลงชื่อเข้าใช้อยู่ และจะถูกขอให้ตั้งค่าในการลงชื่อเข้าใช้ครั้งถัดไป:',
        tenant_mfa_confirm_self: 'คุณเองก็ยังไม่ได้ตั้งค่า MFA ตั้งค่าได้ในการตั้งค่าบัญชีของคุณก่อนการลงชื่อเข้าใช้ครั้งถัดไป',
        tenant_mfa_confirm_button: 'กำหนดให้ใช้ MFA',
        tenant_mfa_setup_required: 'ผู้เช่านี้กำหนดให้ใช้การยืนยันตัวตนหลายปัจจัย ตั้งค่าตอนนี้ มิฉะนั้นคุณจะถูกขอให้ตั้งค่าในการลงชื่อเข้าใช้ครั้งถัดไป',
        tenant_mfa_setup_action: 'ตั้งค่า MFA',
        enterprise_sso: 'Enterprise SSO',
        enterprise_sso_description: 'มีให้บริการในแผนชำระเงิน ติดต่อเราเพื่อเปิดใช้งาน Enterprise SSO เพื่อให้สมาชิกทุกคนสามารถลงชื่อเข้าใช้คอนโซล Logto Cloud โดยใช้ผู้ให้บริการตัวตนขององค์กรของคุณ',
    },
    full_env_tag: {
        development: 'ทดสอบ',
        production: 'โปรดักชั่น',
    },
    deletion_card: {
        title: 'ลบ',
        tenant_deletion: 'ลบผู้เช่า',
        tenant_deletion_description: 'การลบผู้เช่าจะเป็นการลบข้อมูลผู้ใช้และการตั้งค่าทั้งหมดที่เกี่ยวข้องอย่างถาวร โปรดดำเนินการด้วยความระมัดระวัง',
        tenant_deletion_button: 'ลบผู้เช่า',
    },
    leave_tenant_card: {
        title: 'ออกจาก',
        leave_tenant: 'ออกจากผู้เช่า',
        leave_tenant_description: 'ทรัพยากรในผู้เช่าจะยังคงอยู่แต่คุณจะไม่สามารถเข้าถึงผู้เช่านี้ได้อีก',
        last_admin_note: 'หากต้องการออกจากผู้เช่านี้ กรุณาตรวจสอบว่ามีสมาชิกอื่นอย่างน้อยหนึ่งคนที่มีบทบาทผู้ดูแลระบบ',
    },
    create_modal: {
        title: 'สร้างผู้เช่า',
        subtitle: 'สร้างผู้เช่าใหม่ที่มีทรัพยากรและผู้ใช้แยกต่างหาก',
        tenant_id: 'รหัสผู้เช่า',
        tenant_usage_purpose: 'คุณต้องการใช้ผู้เช่านี้เพื่ออะไร?',
        development_description: 'ใช้สำหรับทดสอบเท่านั้นและไม่ควรใช้ในโปรดักชั่น ไม่ต้องการการสมัครสมาชิก',
        development_description_for_private_regions: 'ใช้สำหรับทดสอบเท่านั้นและไม่ควรใช้ในโปรดักชั่น',
        development_hint: 'มีทุกฟีเจอร์โปรแต่มีข้อจำกัด เช่น แบนเนอร์เข้าสู่ระบบ',
        production_description: 'สำหรับการใช้งานโดยผู้ใช้จริงและอาจต้องมีการสมัครสมาชิกแบบชำระเงิน',
        available_plan: 'แผนที่สามารถใช้งานได้:',
        create_button: 'สร้างผู้เช่า',
        tenant_name_placeholder: 'ผู้เช่าของฉัน',
        tenant_created: 'สร้างผู้เช่าสำเร็จ',
        invitation_failed: 'การเชิญบางรายการส่งไม่สำเร็จ กรุณาลองอีกครั้งใน การตั้งค่า -> สมาชิก ในภายหลัง',
        tenant_type_description: 'ไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างแล้ว',
        tenant_id_invalid: 'รหัสผู้เช่าสามารถประกอบด้วยตัวอักษรพิมพ์เล็ก ตัวเลข และเครื่องหมายขีดกลางเท่านั้น และต้องไม่เกิน {{max}} ตัวอักษร',
        tenant_id_placeholder: 'รหัสผู้เช่าของคุณ',
        tenant_id_tip: 'กำหนดรหัสผู้เช่าเอง หากเว้นว่างไว้ Logto จะสร้างรหัสเริ่มต้น รหัสผู้เช่าไม่สามารถเปลี่ยนแปลงได้หลังจากสร้างแล้ว',
    },
    dev_tenant_migration: {
        title: 'ตอนนี้คุณสามารถทดลองใช้ฟีเจอร์ Pro ของเราได้ฟรี โดยสร้าง "ผู้เช่าสำหรับทดสอบ" ใหม่!',
        affect_title: 'มีผลกระทบกับคุณอย่างไร?',
        hint_1: 'เรากำลังแทนที่ <strong>แท็กสภาพแวดล้อมเดิม</strong> ด้วยประเภทผู้เช่าใหม่สองรายการ: <strong>“ทดสอบ”</strong> และ <strong>“โปรดักชั่น”</strong>',
        hint_2: 'เพื่อให้เปลี่ยนผ่านได้อย่างราบรื่นและการทำงานไม่สะดุด ผู้เช่าทั้งหมดที่ถูกสร้างขึ้นก่อนหน้านี้จะถูกอัปเกรดเป็นประเภทผู้เช่า <strong>โปรดักชั่น</strong> พร้อมกับแผนการสมัครสมาชิกของคุณเดิม',
        hint_3: 'ไม่ต้องกังวล การตั้งค่าอื่นๆ ของคุณจะเหมือนเดิม',
        about_tenant_type: 'เกี่ยวกับประเภทผู้เช่า',
    },
    delete_modal: {
        title: 'ลบผู้เช่า',
        description_line1: 'คุณแน่ใจหรือว่าต้องการลบผู้เช่า "<span>{{name}}</span>" พร้อมแท็กสภาพแวดล้อม "<span>{{tag}}</span>"? การดำเนินการนี้ไม่สามารถย้อนกลับ และจะลบข้อมูลและรายละเอียดผู้เช่าทั้งหมดอย่างถาวร',
        description_line2: 'ก่อนลบผู้เช่า เราอาจช่วยคุณได้ <span><a>ติดต่อเราทางอีเมล</a></span>',
        description_line3: 'หากต้องการดำเนินการต่อ กรุณากรอกชื่อผู้เช่า "<span>{{name}}</span>" เพื่อยืนยัน',
        delete_button: 'ลบอย่างถาวร',
        cannot_delete_title: 'ไม่สามารถลบผู้เช่านี้ได้',
        cannot_delete_description: 'ขออภัย คุณไม่สามารถลบผู้เช่านี้ได้ในตอนนี้ กรุณาตรวจสอบว่าคุณใช้งานแผนฟรีและชำระค่าใช้จ่ายทั้งหมดแล้ว',
    },
    leave_tenant_modal: {
        description: 'คุณแน่ใจหรือว่าต้องการออกจากผู้เช่านี้?',
        leave_button: 'ออกจาก',
    },
    tenant_landing_page: {
        title: 'คุณยังไม่ได้สร้างผู้เช่า',
        description: 'เพื่อเริ่มต้นตั้งค่าโปรเจ็กต์กับ Logto กรุณาสร้างผู้เช่าใหม่ หากต้องการออกจากระบบหรือลบบัญชีของคุณ เพียงคลิกที่ปุ่มอวาตาร์ตรงมุมขวาบน',
        create_tenant_button: 'สร้างผู้เช่า',
    },
    status: {
        mau_exceeded: 'เกินจำนวน MAU',
        token_exceeded: 'เกินจำนวนโทเคน',
        suspended: 'ถูกระงับ',
        overdue: 'เกินกำหนดชำระเงิน',
    },
    tenant_suspended_page: {
        title: 'ผู้เช่าถูกระงับ ติดต่อเราเพื่อกู้คืนการเข้าถึง',
        description_1: 'เราขออภัยที่ต้องแจ้งให้ทราบว่าบัญชีผู้เช่าของคุณถูกระงับชั่วคราว เนื่องจากการใช้งานไม่ถูกต้อง เช่น เกินข้อจำกัด MAU, ชำระเงินล่าช้า หรือดำเนินการที่ไม่ได้รับอนุญาต',
        description_2: 'หากคุณต้องการคำชี้แจงเพิ่มเติม มีข้อกังวล หรือประสงค์จะกู้คืนสิทธิ์การใช้งานและปลดล็อกผู้เช่าของคุณ กรุณาติดต่อเราได้ทันที',
    },
    production_tenant_notification: {
        text: 'ตอนนี้คุณอยู่ในผู้เช่าสำหรับทดสอบฟรี สร้างผู้เช่าโปรดักชั่นเพื่อใช้งานจริง',
        action: 'สร้างผู้เช่า',
    },
};
export default Object.freeze(tenants);
